import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { SettingsProvider } from "./context/SettingsContext";
import { ContentProvider } from "./context/ContentContext";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";
import Home from "./pages/Home";
import CategoryPage from "./pages/CategoryPage";
import ProductDetail from "./pages/ProductDetail";
import Factory from "./pages/Factory";
import Gallery from "./pages/Gallery";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import SearchPage from "./pages/SearchPage";
import Customizer from "./pages/Customizer";
import Admin from "./pages/Admin";

const Layout = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin" element={<Admin />} />
      </Routes>
    );
  }

  return (
    <>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/category/:slug" element={<CategoryPage />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/factory" element={<Factory />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/customize" element={<Customizer />} />
        </Routes>
      </main>
      <Footer />
      <Chatbot />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <ContentProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Layout />
            <Toaster />
          </BrowserRouter>
        </ContentProvider>
      </SettingsProvider>
    </div>
  );
}

export default App;
